<template>
  <f7-page
    no-toolbar
    no-navbar
    no-swipeback
  >
    <f7-link
      class="back-no-navbar"
      @click="goBack()"
    >
      <eva-icon
        name="arrow-back-outline"
        fill="#282A43"
        width="32"
        height="32"
      />
    </f7-link>
    <div
      id="map"
      class="map"
    />
    <f7-link
      v-if="mapFinishedLoad"
      :class="`control-tower-search-container ${ !isSearching ? 'not-searching' : ''} ${ followedUserID ? 'following' : ''}`"
      @click="toggleSearch"
    >
      <eva-icon
        v-if="!isSearching && !followedUserID"
        class="control-tower-search"
        name="search-outline"
        fill="#282A43"
        width="32"
        height="32"
      />
      <eva-icon
        v-else
        class="control-tower-search"
        name="close"
        :fill="followedUserID ? '#FF7570' : '#282A43'"
        width="32"
        height="32"
      />
    </f7-link>
    <div
      v-if="hasFound && followedUserID === null && isSearching"
      class="search-result-container"
    >
      <div
        v-for="user in found"
        :key="user.id"
        class="result-user"
        @click="followUser(user.id)"
      >
        <span class="result-title">
          {{ user.name }}
        </span>
        <span :class="`result-streaming ${isStreaming(user) ? 'user-online' : 'user-offline'}`" />
      </div>
    </div>
    <div
      v-if="followedUserID !== null"
      class="searchbar-container followed-user"
    >
      {{ users[followedUserID].name }}
    </div>
    <transition name="fade">
      <div
        v-if="isSearching && followedUserID === null"
        :class="`searchbar-container ${ !hasFound ? 'not-found' : ''}`"
      >
        <input
          ref="searchInput"
          class="searchbar-input"
          :placeholder="`Busca por nombre o cédula`"
          @input="searchAll"
        >
      </div>
    </transition>
    <f7-fab
      slot="fixed"
      class="center-fab"
      position="left-bottom"
      color="dark"
      @click="fitBoundaries"
    >
      <i class="material-icons">
        settings_overscan
      </i>
    </f7-fab>
  </f7-page>
</template>
<script>
import { db, firebaseTools } from '../utils/firebase'
import { Loader } from 'google-maps'
import { mapState } from 'vuex'
// import { f7Fab } from 'framework7-vue'
export default {
  name: 'UserMain',
  components: {
    // f7Fab,
  },
  data () {
    return {
      google: null,
      map: null,
      coronaCircles: [],
      position: null,
      markers: {},
      fitBounds: true,
      users: {},
      boundArray: {},
      followedUserID: null,
      foundPushed: [],
      found: [],
      isSearching: false,
      mapFinishedLoad: false,
    }
  },
  computed: {
    hasFound () {
      return this.found.length > 0
    },
    followedUserPosition () {
      return this.users[this.followedUserID].position
    },
    ...mapState({
      uid: state => state.auth.uid,
      account: state => state.auth.account,
    }),
  },
  watch: {
    isSearching: function () {
      this.found = []
    },
    boundArray: function () {
      if (this.fitBounds) {
        this.map.fitBounds(this.bounds)
      }
    },
    position: function () {
    },
  },
  async mounted () {
    const loader = new Loader('AIzaSyD0Ayj6clybh1B5zglcFagDRIiBbquvDIs')
    this.google = await loader.load()
    this.mapFinishedLoad = true
    this.map = new this.google.maps.Map(document.getElementById('map'), {
      center: { lat: 6.1540293, lng: -75.5327601 },
      zoom: 15,
      zoomControlOptions: {
        position: this.google.maps.ControlPosition.RIGHT_TOP,
      },
      mapTypeControl: false,
      fullscreenControl: false,
      streetViewControl: false,
    })
    this.bounds = new this.google.maps.LatLngBounds()
    db.collection('users').onSnapshot(users => {
      for (const userDoc of users.docs) {
        const userID = userDoc.id
        this.users[userID] = userDoc.data()
        firebaseTools.getDatabaseReference[this.account.realm]('users/' + userID).on('value', userSnapshot => {
          const userData = userSnapshot.val()
          if (!userData) {
            return
          }
          const position = { lat: userData.position.lat, lng: userData.position.lng }
          const timestamp = userData.position.localTimestamp._nanoseconds / 1000000 + userData.position.localTimestamp._seconds * 1000
          this.users[userID].position = { lat: userData.position.lat, lng: userData.position.lng }
          this.users[userID].timestamp = timestamp
          this.bounds.extend({ lat: userData.position.lat + 0.005, lng: userData.position.lng + 0.005 })
          this.bounds.extend({ lat: userData.position.lat + 0.005, lng: userData.position.lng - 0.005 })
          this.bounds.extend({ lat: userData.position.lat - 0.005, lng: userData.position.lng + 0.005 })
          this.bounds.extend({ lat: userData.position.lat - 0.005, lng: userData.position.lng - 0.005 })
          this.$set(this.boundArray, userID, position)
          if (!this.markers[userID]) {
            this.markers[userID] = new this.google.maps.Marker({
              position: position,
              map: this.map,
              label: {
                text: this.users[userID].name || '(Anónimo)',
                fontWeight: '500',
                color: '#282A43',
              },
              icon: {
                url: 'https://firebasestorage.googleapis.com/v0/b/covid-co.appspot.com/o/marker.png?alt=media&token=5434f023-a8ad-4afe-80d6-6e05289ddb15',
                labelOrigin: new this.google.maps.Point(0, 25),
              },
            })
          } else {
            this.markers[userID].setPosition(position)
          }
        })
      }
    })
  },
  methods: {
    isStreaming (user) {
      let timestamp = 0
      if (user.position) {
        if (user.timestamp) {
          timestamp = user.timestamp
        }
      }
      if (Date.now() - timestamp < 60 * 1000) {
        return true
      }
      return false
    },
    fitBoundaries () {
      this.map.fitBounds(this.bounds)
    },
    goBack () {
      this.$f7userr.back()
    },
    toggleSearch () {
      if (this.isSearching || this.followedUserID) {
        this.isSearching = false
        this.followedUserID = null
        this.map.setOptions({ draggable: true, zoomControl: true, scrollwheel: true, disableDoubleClickZoom: false })
      } else {
        this.isSearching = true
      }
      setTimeout(() => {
        this.map.fitBounds(this.bounds)
      }, 700)
    },
    followUser (userID) {
      this.followedUserID = userID
      this.centerUser()
    },
    centerUser () {
      console.info(this.followedUserPosition)
      if (this.followedUserID !== null && typeof this.followedUserPosition !== 'undefined') {
        this.map.panTo({ lat: this.followedUserPosition.lat, lng: this.followedUserPosition.lng })
      }
    },
    parseBadge (schedule) {
      switch (schedule) {
        case 'PICKUP':
          return 'RE'
        case 'DELIVERY':
          return 'EN'
        case 'EXTRA':
          return 'EX'
        default:
          return ''
      }
    },
    searchAll (event) {
      const query = event.target.value
      if (query === '') {
        this.found = []
      } else {
        const localFound = []
        for (const userID of Object.keys(this.users)) {
          if (typeof this.users[userID].name !== 'undefined' && this.users[userID].name) {
            console.info(this.users[userID].name)
            if (this.users[userID].name.toLowerCase().indexOf(query.toLowerCase()) >= 0) {
              if (this.foundPushed.indexOf(userID) < 0) {
                localFound.push({ ...this.users[userID], id: userID })
                this.foundPushed.push(userID)
              }
            }
          }
        }
        this.found = localFound
        this.foundPushed = []
      }
    },
  },
}
</script>
<style lang="scss" scoped>
@import "../css/_brand";
.map {
  width: 100%;
  height: 100%;
}
.center-fab {
  opacity: 0.7;
}
.user-details-page{
  padding: 0 0 50px 0;
}
.user-info-button{
  background: $primary-color !important;
  box-shadow: 0 0 4px $shadow;
  height: 56px;
  width: 56px;
  bottom: 86px !important;
}
.followed-user{
  line-height: 56px;
  background: $secondary-color !important;
  box-sizing: border-box;
  box-shadow: 0 0 4px $shadow;
  padding: 0 56px 0 20px;
  font-weight: 600;
  color: $white;
  white-space: nowrap !important;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14pt;
}
.page-control-tower > .page-content {
  overflow-x: hidden;
}
.fade-enter-active, .fade-leave-active {
  transition: all .5s;
}
.fade-enter, .fade-leave-to {
  transform: translateX(100%);
  opacity: 0;
}
.result-badge{
  float: left;
}
.result-title{
  color: $dark-color;
  width: calc(100% - 20px);
  margin-left: 5px;
  font-size: 12pt;
  font-weight: 400;
}
.result-streaming{
  float: right;
  flex-shrink: 0;
  width: 10px;
  height: 10px;
  border-radius: 50%;
}
.user-online{
  background: $purple;
}
.user-offline{
  background: $red;
}
.result-user{
  cursor: pointer;
  display: flex;
  align-items : center;
  background: $bluegray;
  padding: 5px;
  margin-bottom: 5px;
  box-sizing: border-box;
  border-radius: 8px;
  min-height: 64px;
  width: 100%;
}
.search-result-container{
  position: absolute;
  padding: 10px 10px 70px 10px;
  box-sizing: border-box;
  border-radius: 8px 8px 28px 28px;
  box-shadow: 0 0 4px $shadow;
  bottom: 20px;
  right: 20px;
  width: 90%;
  overflow: auto;
  max-width: $width-pc;
  max-height: calc(100% - 230px);
  background: $white;
  z-index: 1;
}
.search-result-container::-webkit-scrollbar-track{
  margin: 8px;
  background-color: $white;
}

.search-result-container::-webkit-scrollbar{
  width: 8px;
  height: 8px;
}
.search-result-container::-webkit-scrollbar-thumb
{
  border-radius: 8px;
  background-color: rgba(0, 0, 0, 0.12);
}

.control-tower-search-container{
  background: $white;
  border-radius: 50%;
  position: absolute;
  bottom: 20px;
  right: 20px;
  z-index: 2;
}
.control-tower-search{
  width: 32px;
  height: 32px;
  background: none !important;
  padding: 12px;
  border-radius: 50%;
}

.not-found, .not-searching > i {
  box-shadow: 0 0 4px $shadow;
}

.searchbar-container{
  border-radius: 28px;
  position: absolute;
  bottom: 20px;
  right: 20px;
  width: 90%;
  max-width: $width-pc;
  height: 56px;
  background: $white;
  z-index: 1;
}
.searchbar-input{
  box-sizing: border-box;
  padding: 10px 20px;
  border-radius: 28px;
  border: none;
  background: none;
  font-size: 18pt;
  width: calc(100% - 56px);
  height: 56px;
}
.searchbar-control-tower{
  position: absolute;
  bottom: 45px;
  width: 100%;
  height: 20px;
  z-index: 9999;
}
</style>
